import type {AuthSnapshot} from '../../auth.js';
import {isLegalFeatureEnabled} from '../../core/moduleAccess.js';
import {renderLayout} from '../../layout.js';
import {navigate} from '../../router.js';

/** 诉讼台账方案在统一「台账方案」页上的入口。 */
export const LITIGATION_PLANS_PAGE_PATH = '/tax-assistant/plans?kind=legal-litigation';

/** 诉讼台账方案专项编辑页。 */
export const LITIGATION_PLAN_EDITOR_PATH = '/tax-assistant/legal-litigation/plan';

type EditorOptions = {
  planId?: string;
  initialName?: string;
  onDone?: () => void;
};

/**
 * 是否为诉讼台账方案专项编辑路由。
 * @param pathname 当前路径
 */
export function isLitigationPlanEditorPath(pathname = window.location.pathname): boolean {
  const path = pathname.replace(/\/$/, '') || '/';
  return path === LITIGATION_PLAN_EDITOR_PATH || path.startsWith(`${LITIGATION_PLAN_EDITOR_PATH}/`);
}

/**
 * 从专项编辑路由解析已有方案 ID。
 * @param pathname 当前路径
 */
export function litigationPlanEditorPlanId(pathname = window.location.pathname): string {
  const path = pathname.replace(/\/$/, '') || '/';
  const prefix = `${LITIGATION_PLAN_EDITOR_PATH}/`;
  return path.startsWith(prefix) ? decodeURIComponent(path.slice(prefix.length)) : '';
}

/**
 * 生成诉讼台账方案专项编辑地址。
 * @param options 方案 ID 与预填名称
 */
export function litigationPlanEditorHref(options: {planId?: string; name?: string} = {}): string {
  const base = options.planId
    ? `${LITIGATION_PLAN_EDITOR_PATH}/${encodeURIComponent(options.planId)}`
    : LITIGATION_PLAN_EDITOR_PATH;
  const name = options.name?.trim() || '';
  return name ? `${base}?name=${encodeURIComponent(name)}` : base;
}

/**
 * 旧独立方案页跳转到统一台账方案页。
 * @param root 根节点
 * @param auth 登录快照
 */
export async function renderLitigationLedgerPlanPage(root: HTMLElement, auth: AuthSnapshot): Promise<void> {
  if (!isLegalFeatureEnabled('legal-litigation-ledger-v1')) {
    renderLayout(root, auth, `<section class="la-page"><div class="la-empty"><b>诉讼台账已关闭</b></div></section>`);
    return;
  }
  window.history.replaceState({}, '', LITIGATION_PLANS_PAGE_PATH);
  navigate(LITIGATION_PLANS_PAGE_PATH);
}

/**
 * 跳转到诉讼台账方案专项编辑页。
 * @param _root 根节点
 * @param _auth 登录快照
 * @param options 方案 ID、预填名称
 */
export async function renderLitigationPlanEditor(_root: HTMLElement, _auth: AuthSnapshot, options: EditorOptions): Promise<void> {
  navigate(litigationPlanEditorHref({planId: options.planId, name: options.initialName}));
}
